import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Container,
  CircularProgress
} from '@mui/material';
import { LoginOutlined } from '@mui/icons-material';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from '../config/msalConfig';

const LoginScreen: React.FC = () => {
  const { instance, inProgress } = useMsal();

  const handleLogin = async () => {
    console.log('Login attempt - inProgress:', inProgress);

    // Manual cleanup of stuck interaction state
    const clearInteractionState = () => {
      try {
        // Clear all MSAL-related session storage
        sessionStorage.removeItem('msal.interaction.status');
        sessionStorage.removeItem('msal.interaction.in.progress');
        sessionStorage.removeItem('msal.request.params');

        // Clear all MSAL local storage
        Object.keys(localStorage).forEach(key => {
          if (key.startsWith('msal.')) {
            localStorage.removeItem(key);
          }
        });

        console.log('Cleared MSAL interaction state');
      } catch (e) {
        console.log('Error clearing state:', e);
      }
    };

    if (inProgress !== InteractionStatus.None) {
      console.log('MSAL interaction already in progress:', inProgress);
      return;
    }

    try {
      console.log('Starting login redirect...');
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Login redirect failed:', error);

      if (error instanceof Error && error.message?.includes('interaction_in_progress')) {
        console.log('Clearing stuck interaction state and reloading...');
        clearInteractionState();

        // Show user a message and reload
        alert('Authentication state was stuck. Page will reload to reset.');
        setTimeout(() => window.location.reload(), 1000);
      }
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Card sx={{ width: '100%', maxWidth: 400 }}>
          <CardContent sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h4" component="h1" gutterBottom>
              Case Calendar
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              paragraph
              sx={{ mb: 3 }}
            >
              Sign in with your Microsoft account to access the Jury Project Calendar dashboard.
            </Typography>
            <Button
              variant="contained"
              size="large"
              startIcon={inProgress !== InteractionStatus.None ? <CircularProgress size={20} color="inherit" /> : <LoginOutlined />}
              onClick={handleLogin}
              disabled={inProgress !== InteractionStatus.None}
              sx={{
                py: 1.5,
                px: 3,
                fontSize: '1.1rem'
              }}
            >
              {inProgress !== InteractionStatus.None ? 'Signing in...' : 'Sign in with Microsoft'}
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default LoginScreen;
